// ------------------------------------------------------------
// User
//
// TBD
// ------------------------------------------------------------

import moment from 'moment';
import Cookies from 'js-cookie';

const COOKIE_KEY = 'paid';

class User
{
  /**
   * TBD
   *
   * @param {Object} options
   */
  constructor (options = {})
  {
    this.displayName = '';
    this.permissions = {}; // { componentID: permissionLevel } mappings
    this.isLoggedIn = (this.getAccessToken() !== null);

    Object.assign(this, options);
  }

  /**
   * TBD
   */
  login (options = {})
  {
    Object.assign(this, options);
    this.isLoggedIn = true;
  }

  /**
   * Destroys the session information related to this user and reverts them back to an unauthenticated state.
   */
  logout ()
  {
    this.displayName = '';
    this.permissions = {};
    this.isLoggedIn = false;

    Cookies.remove(COOKIE_KEY);
  }

  /**
   * Returns whether or not the user has access to this component at this permission level.
   *
   * @param {Number} componentID
   * @param {Number} permissionLevel
   *
   * @returns {Boolean}
   */
  hasAccess (componentID, permissionLevel)
  {
    let hasAccess = false;
    if (componentID <= 0)
    {
      hasAccess = true;
    }
    else
    {
      // eslint-disable-next-line no-bitwise
      hasAccess = (this.permissions[componentID] & permissionLevel) === permissionLevel;
    }

    return hasAccess;
  }

  /**
   * Returns the user's OAuth access token value. Returns null if the user is not authenticated or if their token has
   * expired.
   *
   * @returns {String|null}
   */
  getAccessToken ()
  {
    let accessToken = null;
    let sessionBean = Cookies.getJSON(COOKIE_KEY);
    if (sessionBean !== undefined && moment().isBefore(sessionBean.expires))
    {
      accessToken = sessionBean.token;
    }

    return accessToken;
  }

  /**
   * Stores the user's OAuth access token (and expiration time) as a cookie.
   *
   * @param accessToken [String] the OAuth access token value
   * @param expiresSeconds [int] the number of seconds until this token expires
   */
  setAccessToken (accessToken, expiresSeconds = 28800)
  {
    let ssl = document.location.protocol === 'https:';
    let expiresTime = moment().add(expiresSeconds, 's').toDate().getTime();

    Cookies.set(COOKIE_KEY, { token: accessToken, expires: expiresTime }, { secure: ssl });
  }
}

export
{
  User
};
